<template>
  <div style="display:inline;">
    <div class="_attachment_list" v-if="!!attachmentList && attachmentList.length>0">
      <div class="_attachment_0" v-for="(each,i) in attachmentList" :key="i">
        <img class="upload_img" v-if="isImage(each)" :src="each.filePath" />
        <a v-else target="_blank" :href="each.filePath">{{each.fileName}}</a>
      </div>
    </div>

    <van-uploader result-type="file" accept="*" :after-read="uploaderAfterRead">
      <van-button size="small" style="width:45vw;">上传图片或视频</van-button>
    </van-uploader>
  </div>
</template>

<script>
import AbstractQiniuUploader from '@/assets/mixins/AbstractQiniuUploader';

export default {
  mixins : [ AbstractQiniuUploader ],

  name: "MobileTicketUpload",

  data() {
    return {
      uploaderDomain: null,
      attachmentList: []
    };
  },

  mounted() {
    // console.log('#28 MobileTicketUpload mounted', this);

    document.addEventListener('paste', this.onDocumentPaste);
  },

  methods: {
    onDocumentPaste(e) {
      if ( !e || !e.clipboardData || !e.clipboardData.items ) {
        console.log('#34 onDocumentPaste, no items', e);
        return;
      }

      var _this = this;

      var items = e.clipboardData.items;
      for (var i = 0; i < items.length; i++) {
        var _file = items[i].getAsFile();
        // console.log('#43', i, items[i], _file);

        this.requestQiniuToken_2('png', _token => {
          _this.uploadToQiniu_2(_file, _token, _attachment => {
            _this.attachmentList.push( _attachment );
          });
        });
      }
    },

    uploadToQiniu(_field, _token) {
      var _this = this;
      _this.uploadToQiniu_2(_field.file, _token, _attachment => {
        _this.attachmentList.push( _attachment );
      });
    },

    getAttachmentList() {
      return this.attachmentList;
    },

    setAttachmentList(_list) {
      this.attachmentList = _list;
    },

    //获取文件后缀名
    getSuffix(fileName) {
      var lastPlace = fileName.lastIndexOf(".");
      var fileNameLength = fileName.length;
      return fileName.substring(lastPlace + 1, fileNameLength);
    },

    requestQiniuToken(_field, _then) {
      var _suffix = this.getSuffix(_field.file.name);
      this.requestQiniuToken_2(_suffix, _then);
    },

    uploaderAfterRead(_field) {
      this.requestQiniuToken(_field, _token => {
        this.uploadToQiniu(_field, _token);
      });
    }
  }
};
</script>

<style scoped>
._attachment_0 {
  display:inline-block;
  max-width: 46.5vw;
  max-height: 46.5vw;
  min-width: 5vw;
  min-height: 5vw;
}

._attachment_list {
  margin-bottom:10px;
  background:#dfe6e63f;
  height: 100px;
  overflow: auto;
}

.upload_img {
  border:1px solid #dec5c5;
  max-width: 46.5vw;
  max-height: 46.5vw;
  width: auto;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketUpload.vue